function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "current",
  strokeWidth: 10,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  cx: 89.665,
  cy: 89.664,
  r: 84.665
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "current",
  strokeWidth: 10,
  strokeMiterlimit: 10,
  d: "M69.744,136.784 c6.293,2.671,12.979,4.022,19.921,4.022c6.936,0,13.622-1.354,19.918-4.027v-28.288l2.176-1.489 c10.69-7.319,17.072-19.408,17.072-32.338c0-21.597-17.569-39.167-39.166-39.167s-39.167,17.57-39.167,39.167 c0,12.929,6.382,25.018,17.072,32.338l2.174,1.49V136.784z"
});

var SvgAccountOutlined = function SvgAccountOutlined(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "179px",
    height: "179px",
    viewBox: "0 0 179 179",
    enableBackground: "new 0 0 179 179",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccountOutlined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account_outlined.423d1ec3.svg";
export { ForwardRef as ReactComponent };